import { defineComponent as v, watchEffect as S, onMounted as y, h as t, renderSlot as _ } from "vue";
import { MONTH_ITEM_HEIGHT as m } from "./ghl-ui.es1287.js";
import { useDualCalendarProps as b, useDualCalendar as $ } from "./ghl-ui.es1311.js";
import { warnOnce as g } from "./ghl-ui.es859.js";
import u from "./ghl-ui.es985.js";
import f from "./ghl-ui.es199.js";
import { XButton as p } from "./ghl-ui.es223.js";
import k from "./ghl-ui.es1135.js";
const A = v({
  name: "MonthRangePanel",
  props: Object.assign(Object.assign({}, b), { type: {
    type: String,
    required: !0
  } }),
  setup(s) {
    process.env.NODE_ENV !== "production" && S(() => {
      var e;
      !((e = s.actions) === null || e === void 0) && e.includes("now") && g("date-picker", `The \`now\` action is not supported for n-date-picker of ${s.type}type`);
    });
    const i = $(s, s.type), c = (e, a, o, n) => {
      const { handleColItemClick: d } = i, h = !1;
      return t("div", { "data-n-date": !0, key: a, class: [
        `${o}-date-panel-month-calendar__picker-col-item`,
        {
          [`${o}-date-panel-month-calendar__picker-col-item--current`]: e.isCurrent,
          [`${o}-date-panel-month-calendar__picker-col-item--selected`]: e.selected,
          [`${o}-date-panel-month-calendar__picker-col-item--disabled`]: h
        }
      ], onClick: () => {
        d(e, n);
      } }, e.type === "month" ? e.dateObject.month + 1 : e.type === "quarter" ? `Q${e.dateObject.quarter}` : e.dateObject.year);
    };
    return y(() => {
      i.justifyColumnsScrollState();
    }), Object.assign(Object.assign({}, i), { renderItem: c });
  },
  render() {
    var s, i, c;
    const { mergedClsPrefix: e, mergedTheme: a, shortcuts: o, type: n, renderItem: d, onRender: h } = this;
    return h == null || h(), t(
      "div",
      { ref: "selfRef", tabindex: 0, class: [
        `${e}-date-panel`,
        `${e}-date-panel--daterange`,
        !this.panel && `${e}-date-panel--shadow`,
        this.themeClass
      ], onKeydown: this.handlePanelKeyDown, onFocus: this.handlePanelFocus },
      t(
        "div",
        { ref: "startDatesElRef", class: `${e}-date-panel-calendar ${e}-date-panel-calendar--start` },
        t(
          "div",
          { class: `${e}-date-panel-month-calendar` },
          t(u, { ref: "startYearScrollbarRef", class: `${e}-date-panel-month-calendar__picker-col`, theme: a.peers.Scrollbar, themeOverrides: a.peerOverrides.Scrollbar, container: () => this.virtualListContainer("start"), content: () => this.virtualListContent("start"), horizontalRailStyle: { zIndex: 1 }, verticalRailStyle: { zIndex: 1 } }, {
            default: () => t(f, { ref: "startYearVlRef", items: this.startYearArray, itemSize: m, showScrollbar: !1, keyField: "ts", onScroll: this.handleStartYearVlScroll, paddingBottom: 4 }, {
              default: ({ item: l, index: r }) => d(l, r, e, "start")
            })
          }),
          n === "monthrange" || n === "quarterrange" ? t(
            "div",
            { class: `${e}-date-panel-month-calendar__picker-col` },
            t(u, { ref: "startMonthScrollbarRef", theme: a.peers.Scrollbar, themeOverrides: a.peerOverrides.Scrollbar }, {
              default: () => [
                (n === "monthrange" ? this.startMonthArray : this.startQuarterArray).map((l, r) => d(l, r, e, "start")),
                n === "monthrange" && t("div", { class: `${e}-date-panel-month-calendar__padding` })
              ]
            })
          ) : null
        )
      ),
      t("div", { class: `${e}-date-panel__vertical-divider` }),
      t(
        "div",
        { ref: "endDatesElRef", class: `${e}-date-panel-calendar ${e}-date-panel-calendar--end` },
        t(
          "div",
          { class: `${e}-date-panel-month-calendar` },
          t(u, { ref: "endYearScrollbarRef", class: `${e}-date-panel-month-calendar__picker-col`, theme: a.peers.Scrollbar, themeOverrides: a.peerOverrides.Scrollbar, container: () => this.virtualListContainer("end"), content: () => this.virtualListContent("end"), horizontalRailStyle: { zIndex: 1 }, verticalRailStyle: { zIndex: 1 } }, {
            default: () => t(f, { ref: "endYearVlRef", items: this.endYearArray, itemSize: m, showScrollbar: !1, keyField: "ts", onScroll: this.handleEndYearVlScroll, paddingBottom: 4 }, {
              default: ({ item: l, index: r }) => d(l, r, e, "end")
            })
          }),
          n === "monthrange" || n === "quarterrange" ? t(
            "div",
            { class: `${e}-date-panel-month-calendar__picker-col` },
            t(u, { ref: "endMonthScrollbarRef", theme: a.peers.Scrollbar, themeOverrides: a.peerOverrides.Scrollbar }, {
              default: () => [
                (n === "monthrange" ? this.endMonthArray : this.endQuarterArray).map((l, r) => d(l, r, e, "end")),
                n === "monthrange" && t("div", { class: `${e}-date-panel-month-calendar__padding` })
              ]
            })
          ) : null
        )
      ),
      this.datePickerSlots.footer ? t("div", { class: `${e}-date-panel-footer` }, _(this.datePickerSlots, "footer")) : null,
      !((s = this.actions) === null || s === void 0) && s.length || o ? t(
        "div",
        { class: `${e}-date-panel-actions` },
        t("div", { class: `${e}-date-panel-actions__prefix` }, o && Object.keys(o).map((l) => {
          const r = o[l];
          return Array.isArray(r) || typeof r == "function" ? t(p, { size: "tiny", onMouseenter: () => {
            this.handleRangeShortcutMouseenter(r);
          }, onClick: () => {
            this.handleRangeShortcutClick(r);
          }, onMouseleave: () => {
            this.handleShortcutMouseleave();
          } }, { default: () => l }) : null;
        })),
        t(
          "div",
          { class: `${e}-date-panel-actions__suffix` },
          !((i = this.actions) === null || i === void 0) && i.includes("clear") ? t(p, { theme: a.peers.Button, themeOverrides: a.peerOverrides.Button, size: "tiny", onClick: this.handleClearClick }, { default: () => this.locale.clear }) : null,
          !((c = this.actions) === null || c === void 0) && c.includes("confirm") ? t(p, { theme: a.peers.Button, themeOverrides: a.peerOverrides.Button, size: "tiny", type: "primary", disabled: this.isRangeInvalid, onClick: this.handleConfirmClick }, { default: () => this.locale.confirm }) : null
        )
      ) : null,
      t(k, { onFocus: this.handleFocusDetectorFocus })
    );
  }
});
export {
  A as default
};
